import axios from "axios";
import { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../../Css/Avis.css';
import Slider from "react-slick";
import '../../App.css';


const SelectAvis = () => {

    
    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        speed: 4000,
        autoplaySpeed: 5000,
        // cssEase: "linear",
        arrows:true,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
    };

    const [avis,setAvis] = useState([]);

    useEffect(() =>{
        const fetchAvis = async ()=>{
            try
            {
                const res = await axios.get("https://astraya.ch:4005/avis");
                setAvis(res.data);
            }
            catch(err)
            {
                console.log(err);
            }
        }
        fetchAvis();
    },[]);


    return (
        <div className="slider-container">
            <Slider {...settings}>
                {avis.map(line =>(
                    <div key={line.id_avis} className='sliderTile'>
                        <div className='avisEtoile'>
                            {(() => {
                                const listItems = [];
                                for (let i = 0; i < 5; i++) {
                                    if (i < line.note) 
                                    {
                                        listItems.push(<img alt="étoile" key={i} className='etoile'src='./images/icons/star-icon.png'></img>)
                                    }
                                    else
                                    {
                                        listItems.push(<img alt="étoile-vide" key={i} className='etoile'src='./images/icons/star-line-yellow-icon.png'></img>)
                                    }
                                }
                                return listItems
                            })()}
                        </div>
                        <div className='avisUtilisateur'>
                            <div className='avisNomUtilisateur'>
                                {line.nom_utilisateur}
                            </div>
                            {line.message && <div className='avisPhrase'>{line.message}</div>}
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    )
}

export default SelectAvis;